import '@babel/polyfill'

// IE 에서 forEach 안되는 문제 해결
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

import './plugins'               // 플러그인
import './plugins/filters'       // 필터
import './plugins/directives'    // directives
import './assets/css/common.css' // CSS
import './assets/css/style.css?v=2'  // CSS
import './components-ui'         // 기본 UI 컴포넌트

import Vue     from 'vue'
import App     from './layouts/_layout_App.vue'

import router  from './router' // 라우터 인스턴스 생성
import store   from './store'  // 스토어 인스턴스 생성
import config  from './plugins/config'

import {sync   } from 'vuex-router-sync' // https://www.npmjs.com/package/vuex-router-sync
import {setAuth} from './auth'
sync(store, router)
setAuth(store, router)

Vue.config.productionTip = false // 콘솔로그에 배포팁 코멘트 나오지 않도록
Vue.prototype.$api = config.API_PATH
Vue.prototype._config = config

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#wrap')
